import React from "react";
import RelevantLinkBlock from "../fragments/RelevantLinkBlock";
import {Link} from "react-router-dom";

export default function Article6() {

    let relevantUrls = ["/vehicleOrder/catalog?vehicleCategory=CHN_ORDER", "/vehicleOrder/pricing", "/loan", "/listing"];

    return (
        <div className="site-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-7 blog-content ml-auto order-lg-1">
                        <h2>100% налоговый вычет для электромобилей: будьте в тренде!</h2>

                        <div style={{textAlign: 'justify'}}>
                            <img src="/building_main.JPEG" className="img-fluid py-2" alt="Фото автоплощадки"/>
                            <p>
                                В последние годы электромобили становятся всё более популярными, не только благодаря
                                своей
                                экологичности, но и за счёт выгодных финансовых возможностей для бизнеса. Одним из самых
                                привлекательных аспектов появилось право получить 100% налоговый вычет на инвестиции в
                                электромобили. Рассмотрим, как это работает в рамках законодательства РБ.
                            </p>
                            <p>Согласно Указу Президента от 12.03.2020 г. No 92 «О стимулировании использования
                                электромобилей», у юридических лиц появилось право до 31. 12. 2025 года использовать
                                инвестиционный вычет от первоначальной стоимости основных средств, включая электромобили
                                и
                                расходы на их реконструкцию, в пределах 100 процентов их первоначальной стоимости
                                (стоимости
                                вложений в реконструкцию). Это означает, что организации могут частично компенсировать
                                затраты на приобретение электромобилей, существенно снижая свою налогооблагаемую базу.
                            </p>
                            <img src="/pictures/blog/IMG_7213.JPG" style={{width:'100%'}} className="img-fluid py-2"
                                 alt="Фото налоговый вычет"/>
                            <p>Согласно Налоговому законодательству, сумма инвестиционного вычета распределяется по
                                производственным затратам в течение двух лет, начиная с момента, когда начинается
                                начисление
                                амортизации. Это уменьшит не только налоговую нагрузку, но и способствует продуктивно
                                управлять финансами.</p>
                            <p>Особенно стоит отметить, что для таксопарков и каршеринговых компаний с 2024 года
                                открываются
                                новые горизонты: теперь они тоже смогут применять инвестиционный вычет на автомобили,
                                используемые для краткосрочной аренды. Это дополнение к Налоговому кодексу приняло во
                                внимание схожесть этих видов услуг.
                                Важно помнить, что, хотя инвестиционный вычет и предоставляет хорошие возможности, его
                                применение требует соблюдения некоторых правил. Например, нужно будет восстановить
                                инвестиционный вычет при передаче основных средств, по которым применялся инвестиционный
                                вычет, в аренду.
                            </p>
                            <img src="/pictures/blog/taxi_img.JPG" style={{width:'100%'}} className="img-fluid py-2"
                                 alt="Фото такси"/>
                            <p>В заключение, возможность 100% налогового вычета для электромобилей — это не просто
                                очередной
                                налоговый бонус, а реальный шанс продвинуть свой бизнес на пути к экологической
                                устойчивости
                                и финансовой продуктивности. Для организаций, желающих внедрить в свой бизнес
                                электромобили,
                                это не просто хорошая инвестиция, но и шаг к современному и ответственно настроенному
                                бизнесу.
                            </p>
                        </div>

                    </div>

                    <div className="col-lg-4 order-lg-2">
                        <RelevantLinkBlock relevantUrls={relevantUrls}/>
                    </div>

                </div>
            </div>
        </div>

    );

}
